import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import {
    useBuyerIncentivesV2ClientVariantA,
    useBuyerIncentivesV2ClientVariantB,
} from './buyerIncentivesV2Helpers';

export const BuyerProtection: FC = () => {
    const isVariantA = useBuyerIncentivesV2ClientVariantA();
    const isVariantB = useBuyerIncentivesV2ClientVariantB();

    if (isVariantA) {
        return (
            <FormattedMessage
                id="useCoreBuyerIncentives.moneyBackGuarantee"
                defaultMessage="Money-Back Guarantee"
            />
        );
    }

    if (isVariantB) {
        return (
            <FormattedMessage
                id="useCoreBuyerIncentives.purchaseProtection"
                defaultMessage="Purchase Protection"
            />
        );
    }

    return null;
};
